import Link from 'next/link'
import Badge from './Badge'

interface Props {
  type: string
  size?: string
  children?: any
  href?: string
  className?: string
  badge?: any
  badgeRight?: string
  link?: boolean
  badgeClass?: string
  onClick?: (e: any) => void
}

const ButtonExternal = ({
  type,
  children,
  href,
  size = 'normal',
  className = '',
  badge,
  badgeRight,
  badgeClass,
  ...rest
}: Props) => {
  const classes = {
    base: 'focus:outline-none transition ease-in-out duration-300 cursor-pointer rounded-full  whitespace-nowrap relative inline-block',
    size: {
      normal: 'py-2 px-9 text-base',
      medium: 'py-1.5 px-12 text-base',
      large: 'py-2 px-7 text-xl',
      big: 'py-3 px-10 text-2xl',
    },
    types: {
      primary:
        'bg-primary hover:bg-primary-hover text-white border-3 border-primary hover:border-primary-hover font-normal',
      secondary: 'border-3 border-black hover:bg-gray-dark',
      white: 'border-3 bg-white border-gray-dark hover:border-black',
      action:
        'border-3 border-action bg-action text-white hover:bg-action-hover',
    },
    badgeClass: 'absolute',
  } as const

  const badgeStyle = {
    position: 'absolute',
    top: '-22px',
    right: badgeRight || '10px',
    transform: 'rotate(-10deg)',
  }

  return (
    <>
      {href ? (
        <a
          href={href}
          className={`${className} ${classes.base} ${
            classes.size[size?.toLowerCase() as 'large' | 'normal']
          } ${classes.types[type.toLowerCase() as 'primary' | 'secondary']}`}
        >
          <span className='flex items-center justify-center'>
            {badge ? (
              <Badge
                className={`${classes.badgeClass} ${badgeClass}`}
                title={badge}
                style={badgeStyle}
              />
            ) : (
              ''
            )}
            {children}
          </span>
        </a>
      ) : (
        <a
          className={`${className} ${classes.base} ${
            classes.size[size?.toLowerCase() as 'large' | 'normal']
          } ${classes.types[type.toLowerCase() as 'primary' | 'secondary']}`}
          {...rest}
        >
          <span className='flex items-center justify-center'>
            {badge ? (
              <Badge
                className={`${classes.badgeClass} ${badgeClass}`}
                title={badge}
                style={badgeStyle}
              />
            ) : (
              ''
            )}
            {children}
          </span>
        </a>
      )}
    </>
  )
}

export default ButtonExternal
